import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import {
    SearchResponseModel,
    SearchTypesModel,
    SearchFilterModel,
    ApiResponse
} from '../models';

/**
 * Search API Service
 */
@Injectable({
    providedIn: 'root'
})
export class SearchService extends BaseApiService {

    /**
     * Search by term
     */
    search(searchTerm: string): Observable<ApiResponse<SearchResponseModel>> {
        return this.get<SearchResponseModel>(`/search/${encodeURIComponent(searchTerm)}`);
    }

    /**
     * Search with filters
     */
    searchWithFilters(filter: SearchFilterModel): Observable<ApiResponse<SearchResponseModel>> {
        return this.post<SearchResponseModel>('/search/filter', filter);
    }

    /**
     * Get available search types
     */
    getSearchTypes(): Observable<ApiResponse<SearchTypesModel>> {
        return this.get<SearchTypesModel>('/search/types');
    }
}
